import api from "../lib/api";

export type SavedGrant = {
  id: number;
  grant?: any;
  grant_title?: string | null;
  grant_deadline?: string | null;
  decision_due?: string | null;
  contact_method?: string | null;
  status:
    | "saved"
    | "in_progress"
    | "applied"
    | "draft"
    | "archived"
    | "pending"
    | "approved"
    | "awarded"
    | "rejected";
  notes?: string | null;
  updated_at?: string | null;
  attachments?: any[] | null;
  activity?: string | null;
  url?: string | null;
  outcome?: string | null;
  match_score?: number | null;
};

export type NewSavedGrantPayload = {
  status: SavedGrant["status"];
  notes?: string;
  reminder_at?: string;
};

export type SavedGrantsOverview = {
  active_grants: SavedGrant[];
  past_applications: SavedGrant[]; 
};


export async function getSavedGrantsOverview() {
  const { data } = await api.get<SavedGrantsOverview>("/organizer/saved-grants/");
  return data;
}

export async function postSavedGrant(payload: NewSavedGrantPayload) {
  const { data } = await api.post<SavedGrant>("/organizer/saved-grants/", payload);
  return data;
}

export async function postOutcomeGrant(id: number, outcome: string) {
  const { data } = await api.patch(`/organizer/saved-grants/${id}/update-details/`, {outcome});
  return data;
}


export async function savedGrantDelete(id: number){
  const {data} = await api.delete(`/organizer/saved-grants/${id}/`)
  return data;
}

export async function getStatusChoices(){
  const {data} = await api.get("/organizer/saved-grants/status-choices/")
  return data;
}

export async function getOutcomeChoices(){
  const {data} = await api.get("/organizer/saved-grants/outcome-choices/")
  return data;
}

export async function getContactMethodChoices(){
  const {data} = await api.get("/organizer/saved-grants/contact-method-choices/")
  return data;
}

export async function postContactMethodGrant(id: number, contact_method: string) {
  const { data } = await api.patch(`/organizer/saved-grants/${id}/update-details/`, { contact_method });
  return data;   
}

export async function postStatusGrant(id: number, status: string) {
  const { data } = await api.patch(`/organizer/saved-grants/${id}/update-details/`, { status });
  return data;
}

export async function postFilesApplication(payload: {
  grant: string;
  saved_grant: number | string;
  files: File;
}) {
  const formData = new FormData();
  formData.append("grant", payload.grant.toString());
  formData.append("saved_grant", payload.saved_grant.toString());
  formData.append("files", payload.files);

  const { data } = await api.post("/organizer/saved-grants/upload-attachments/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
}


